"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
/**
 * Use: <span data-number-counter="true" data-number-counter-delay="300" data-number-counter-tick="20">150</h2>
 * data-number-counter-delay -> optional delay time
 * data-number-counter-tick -> optional tick interval 
 */
var NumberCounter = /*#__PURE__*/function () {
  function NumberCounter(container) {
    var _this = this;
    _classCallCheck(this, NumberCounter);
    var TICK_INTERVAL = 50;
    this.container = $(container);
    this.currentValue = 0;
    this.finalValue = parseInt(this.container.text());
    this.startDelay = parseInt(this.container.data('numberCounterDelay'));
    this.tickDelay = this.container.data('numberCounterTick') ? parseInt(this.container.data('numberCounterTick')) : TICK_INTERVAL;
    this.tickInterval;
    this.largerValues = 999; //increase tick steps for number greater than this
    this.largerValuesTickStep = 25;

    // set initial value
    this.update();

    // start delay
    setTimeout(function () {
      // tick delay
      _this.tickInterval = setInterval(function () {
        _this.count();
      }, _this.tickDelay);
    }, this.startDelay);
  }
  return _createClass(NumberCounter, [{
    key: "update",
    value: function update() {
      this.container.text(String(this.currentValue));
    }
  }, {
    key: "count",
    value: function count() {
      if (this.currentValue < this.finalValue) {
        if (this.finalValue > this.largerValues) {
          this.currentValue = this.currentValue + this.largerValuesTickStep;
        } else {
          this.currentValue++;
        }
        this.update();
      } else {
        this.currentValue = this.finalValue;
        this.update();
        clearInterval(this.tickInterval);
        this.container.parent().find('.counterTempHiddenElement').addClass('showHiddenElement');
      }
    }
  }]);
}();